var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/cooking_appliances_table.template.html');
require('../../libs/handlebars/handlebars-helpers.ts');

var TheView = GenericView.extend({
    el: '#cooking_appliances .table-container',
    tagName: '',
	template: Handlebars.compile(Template),
	initialize: function (options) {
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        var params = {
            appliances: [
                {"title": "1. Electric hob", "applianceType": "Electric_Hob"},
                {"title": "2. Electric oven", "applianceType": "Electric_Oven"},
                {"title": "3. Microwave oven", "applianceType": "Microwave_Oven"},
                {"title": "4. Electrical kettle", "applianceType": "Kettle"},
                {"title": "5. Grill", "applianceType": "Grill"},
                {"title": "6. Coffee maker", "applianceType": "Coffee_Maker"},
                {"title": "7. Deep fryer", "applianceType": "Deep_Fryer"},
                {"title": "8. Steam cooker", "applianceType": "Steam_Cooker"},
                {"title": "9. Toaster", "applianceType": "Toaster"},
                {"title": "10. Blender/Juicer", "applianceType": "Food_Processor"},
                {"title": "11. Electric Mixer", "applianceType": "Electric_Mixer"},
                {"title": "12. Kitchen extractor", "applianceType": "Kitchen_Extractor"}
            ]
        };

        this.$el.html(this.template(params));
    }
});

module.exports= TheView;